import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  getAllFinacUsersAction,
  resetFinacUsersList,
  resetSession,
} from "../../../redux/auth";
import {
  getClientMeetUpChecklistAction,
  getSingleClientMeetUpChecklistAction,
  resetClientDirectoryError,
  resetClientDirectoryFetching,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
  resetClientMeetUpChecklistData,
  resetSingleClientMeetUpCheklistData,
} from "../../../redux/clientDirectory";
import {
  GetClientMeetUpChecklistPayloadType,
  GetSingleClientMeetUpChecklistPayloadType,
} from "../../../commonTypes/clientDirectoryTypes";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import AllClientMeetUpStatusTable from "../../../components/LeadModule/ClientMeetUp/AllClientMeetUpStatusTable";
import { Toaster } from "react-hot-toast";
import { SearchIcon } from "../../../components/Icon";
import AllClientMeetUpRightDrawer from "../../../components/LeadModule/ClientMeetUp/AllClientMeetUpRightDrawer";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import useDebounce from "../../../customHooks/useDebounce";
import ClientMeetUpSorting from "../../../components/LeadModule/ClientMeetUp/ClientMeetUpSorting";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import AllClientMeetUpFilter from "../../../components/LeadModule/ClientMeetUp/AllClientMeetUpFilter";
import { MeetUpFilterFieldsType } from "../../../redux/clientDirectory/clientDirectoryType";

type AppProps = {
  history: any;
  fetching: boolean;
  message: string | null;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  totalCount: any;
  finacUser: any;
  loginData: LoginResponseType;
  clientMeetUpChecklistData: any;
  singleClientMeetUpCheckListData: any;
  dispatchGetClientMeetUpData: (
    data: GetClientMeetUpChecklistPayloadType
  ) => void;
  dispatchGetSingleClientMeetUpList: (
    data: GetSingleClientMeetUpChecklistPayloadType
  ) => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchResetSingleClientMeetUpChecklist: () => void;
  dipatchResetClientMeetUpChecklistAction: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetError: () => void;
  dispatchResetMessage: () => void;
  dispatchResetStatusCode: () => void;
  dispatchResetFetching: () => void;
  dispatchResetSession: () => void;
  dispatchResetFinacUsersList: () => void;
};

const AllClientMeetUpStatus = ({
  history,
  fetching,
  message,
  success,
  error,
  statusCode,
  token,
  totalCount,
  loginData,
  finacUser,
  dispatchGetClientMeetUpData,
  dispatchGetSingleClientMeetUpList,
  clientMeetUpChecklistData,
  singleClientMeetUpCheckListData,
  dipatchResetClientMeetUpChecklistAction,
  dispatchResetSingleClientMeetUpChecklist,
  dispatchGetAllFinacUsersAction,
  dispatchResetSuccess,
  dispatchResetError,
  dispatchResetMessage,
  dispatchResetStatusCode,
  dispatchResetFetching,
  dispatchResetSession,
  dispatchResetFinacUsersList,
}: AppProps) => {
  const [data, setData] = useState<any>([]);
  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [filterToggle, setFilterToggle] = useState(false);
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [text, setText] = useState<string>("");
  const [clientCode, setClientCode] = useState<number | null>(null);
  const [apiCall, setApiCall] = useState<boolean>(false);
  const [filterValue, setFilterValue] = useState<MeetUpFilterFieldsType>({
    leadAssignedTo: {
      label: "select...",
      value: "",
    },
    meetingAssignedTo: {
      label: "select...",
      value: "",
    },
    meetingStatus: {
      label: "select...",
      value: "",
    },
  });
  const [multiSelectData, setMultiSelectData] =
    useState<MeetUpFilterFieldsType>({
      leadAssignedTo: {
        label: "select...",
        value: "",
      },
      meetingAssignedTo: {
        label: "select...",
        value: "",
      },
      meetingStatus: {
        label: "select...",
        value: "",
      },
    });
  const [filterOffset, setFilterOffset] = useState<any>(0);
  const [sortBy, setSortBy] = useState({
    id: "Newest first",
    value: "",
    _id: "",
    name: "Newest first",
  });

  const handleEditMeetUp = (id: number) => {
    dispatchResetSingleClientMeetUpChecklist();
    setIsDrawerOpen(true);
    setClientCode(id);
    if (token) {
      dispatchResetSingleClientMeetUpChecklist();
      let finalData = {
        token,
        clientCode: id,
      };

      dispatchGetSingleClientMeetUpList(finalData);
    }
  };

  const closeDrawer = () => {
    setClientCode(null);
    setIsDrawerOpen(false);
  };

  useEffect(() => {
    dispatchResetSuccess();
    dispatchResetError();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetFetching();
    dipatchResetClientMeetUpChecklistAction();
  }, []);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < (totalCount ? +totalCount : 0) &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (clientMeetUpChecklistData?.length > 0) {
          if (!fetching && offset < +totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
        return {
            value: user?.user_id,
            label: `${user?.first_name} ${user?.last_name}`,
            image: user?.profile_pic?.file_url
        };
    })
    if (filterOffset > 0) {
        setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
        setFinalUserList(finalUserData);
    }
}, [finacUser])

  const handleSort = (data: any) => {
    setOffset(0);
    setSortBy(data);
  };

  useEffect(() => {
    if (token) {
        let finalUserData = {
            token,
            offset:filterOffset,
            limit,
            user_type: 'stco_users',
            status: 1,
            search_term: text,
        };
        if (filterOffset <= finacUser?.total_count) {
            dispatchGetAllFinacUsersAction(finalUserData)
        }
    }
}, [filterOffset])

  const fetchNewFinacUserData = (filterText: string) => {
    let finalUserData = {
      token,
      offset: 0,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: filterText,
    };

    dispatchGetAllFinacUsersAction(finalUserData);
  };

  useDebounce(() => {
      if (text) {
        fetchNewFinacUserData(text)
      }
      else {
          const finalData = {
              token,
              offset,
              limit,
              user_type: 'stco_users',
              status: 1,
              search_term: text,
          }
          dispatchGetAllFinacUsersAction(finalData)
      }
   
}, 500, [text]);

  useEffect(() => {
    if (clientMeetUpChecklistData?.length === 0) {
      setData([...clientMeetUpChecklistData]);
    }

    if (offset === 0 && clientMeetUpChecklistData?.length > 0) {
      setData([...clientMeetUpChecklistData]);
    } else if (offset > 0 && !fetching) {
        setData((prv: any) => [...prv, ...clientMeetUpChecklistData]);
    } else {
      if (clientMeetUpChecklistData?.length === 0) {
        setData([...clientMeetUpChecklistData]);
      }
    }
  }, [clientMeetUpChecklistData]);

  const handleSearch = (e: any) => {
    setSearchData(e.target.value);
  };

  useEffect(() => {
    if (token) {
      let sortingBy = sortBy?._id?.split("#");
      let finalData = {
        token,
        role: "admin",
        limit,
        offset,
        searchData,
        sortBy: sortingBy?.length ? sortingBy[0] : "",
        sortOrder: sortingBy?.length ? sortingBy[1] : "",
        meetingAssignedTo: filterValue?.meetingAssignedTo?.value,
        leadAssignedTo: filterValue?.leadAssignedTo?.value,
        meetUpCompleted:
          filterValue?.meetingStatus?.value === "completed"
            ? true
            : filterValue?.meetingStatus?.value === "pending"
            ? false
            : "",
      };

      if (offset < +totalCount) {
        dispatchGetClientMeetUpData(finalData);
        setApiCall(true);
      } else if (offset === 0 && !fetching && +totalCount === 0) {
        dipatchResetClientMeetUpChecklistAction();
        setData([]);
        dispatchGetClientMeetUpData(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    if (apiCall) {
      let sortingBy = sortBy?._id?.split("#");
      let finalData = {
        token,
        role: "admin",
        limit,
        offset,
        searchData,
        sortBy: sortingBy?.length ? sortingBy[0] : "",
        sortOrder: sortingBy?.length ? sortingBy[1] : "",
        meetingAssignedTo: filterValue?.meetingAssignedTo?.value,
        leadAssignedTo: filterValue?.leadAssignedTo?.value,
        meetUpCompleted:
          filterValue?.meetingStatus?.value === "completed"
            ? true
            : filterValue?.meetingStatus?.value === "pending"
            ? false
            : "",
      };
      dispatchGetClientMeetUpData(finalData);
    }
  }, [sortBy]);

  const fetchNewData = (searchData: string) => {
    if(offset>0){
      setOffset(0)
    }
    else{
      let sortingBy = sortBy?._id?.split("#");
      const finalData = {
        token,
        role: "admin",
        limit,
        offset:0,
        searchData,
        sortBy: sortingBy?.length ? sortingBy[0] : "",
        sortOrder: sortingBy?.length ? sortingBy[1] : "",
        meetingAssignedTo: filterValue?.meetingAssignedTo?.value,
        leadAssignedTo: filterValue?.leadAssignedTo?.value,
        meetUpCompleted:
          filterValue?.meetingStatus?.value === "completed"
            ? true
            : filterValue?.meetingStatus?.value === "pending"
            ? false
            : "",
      };
      dispatchGetClientMeetUpData(finalData);
    }
  };

  useDebounce(
    () => {
      if (apiCall) {
        if (searchData) {
          fetchNewData(searchData);
        } else {
          let sortingBy = sortBy?._id?.split("#");
          const finalData = {
            token,
            role: "admin",
            limit,
            offset:0,
            searchData: "",
            sortBy: sortingBy?.length ? sortingBy[0] : "",
            sortOrder: sortingBy?.length ? sortingBy[1] : "",
            meetingAssignedTo: filterValue?.meetingAssignedTo?.value,
            leadAssignedTo: filterValue?.leadAssignedTo?.value,
            meetUpCompleted:
              filterValue?.meetingStatus?.value === "completed"
                ? true
                : filterValue?.meetingStatus?.value === "pending"
                ? false
                : "",
          };
          dispatchGetClientMeetUpData(finalData);
        }
      }
    },
    500,
    [searchData]
  );

  const handleApplyFilter = () => {
    dipatchResetClientMeetUpChecklistAction();
    setMultiSelectData({
      leadAssignedTo: filterValue?.leadAssignedTo,
      meetingAssignedTo: filterValue?.meetingAssignedTo,
      meetingStatus: filterValue?.meetingStatus,
    });

    if(offset>0){
      setOffset(0);
    }
    
    
    if (token && offset===0) {
      let sortingBy = sortBy?._id?.split("#");
      const finalData = {
        token,
        role: "admin",
        limit,
        offset:0,
        searchData: "",
        sortBy: sortingBy?.length ? sortingBy[0] : "",
        sortOrder: sortingBy?.length ? sortingBy[1] : "",
        meetingAssignedTo: filterValue?.meetingAssignedTo?.value,
        leadAssignedTo: filterValue?.leadAssignedTo?.value,
        meetUpCompleted:
          filterValue?.meetingStatus?.value === "completed"
            ? true
            : filterValue?.meetingStatus?.value === "pending"
            ? false
            : "",
      };
      dispatchGetClientMeetUpData(finalData);
    }
  };

  const handleFilterClear = () => {
    if(offset>0){
      setOffset(0)
    }
    else{
      if (token) {
        let sortingBy = sortBy?._id?.split("#");
        const finalData = {
          token,
          role: "admin",
          limit,
          offset:0,
          searchData: "",
          sortBy: sortingBy?.length ? sortingBy[0] : "",
          sortOrder: sortingBy?.length ? sortingBy[1] : "",
          meetingAssignedTo: "",
          leadAssignedTo: "",
          meetUpCompleted: "",
        };
        dispatchGetClientMeetUpData(finalData);
      }
    }
    

    setMultiSelectData({
      leadAssignedTo: {
        label: "Select...",
        value: "",
      },
      meetingAssignedTo: {
        label: "Select...",
        value: "",
      },
      meetingStatus: {
        label: "select...",
        value: "",
      },
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [clientMeetUpChecklistData]);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSuccess();
              dispatchResetError();
              dispatchResetMessage();
              dispatchResetStatusCode();
              dispatchResetFetching();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader title="All Client Meet Up Status List" />
      </div>

      <div className="col-md-12 ">
        <div className="jobs-card" style={{ position: "relative" }}>
          <div>
            <div className="header">
              <div className="left-header">
                <div>
                  <div className="heading"> All Client Meet Up Status List</div>

                  {!fetching && (
                    <div
                      className="sub-heading"
                      style={{ marginTop: "-22px" }}
                    >{`Total  ${
                      totalCount ? totalCount : 0
                    } Meetup status list found`}</div>
                  )}
                </div>
              </div>
              <div className="right-header">
                <div className="col-md-9 position-relative ">
                  <span
                    style={{ position: "absolute", top: "8px", left: "25px" }}
                  >
                    <SearchIcon />
                  </span>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search..."
                    onChange={(e: any) => handleSearch(e)}
                    style={{ paddingLeft: "35px" }}
                    value={searchData}
                  />
                </div>

                <div>
                  <ClientMeetUpSorting
                    handleChange={handleSort}
                    selectedData={sortBy}
                  />
                </div>

                <div>
                  <div className=" mr-1">
                    <AllClientMeetUpFilter
                      setToggle={setFilterToggle}
                      toggle={filterToggle}
                      finalUserList={finalUserList}
                      fetching={fetching}
                      filterValue={filterValue}
                      setoffset={setFilterOffset}
                      setFilterValue={setFilterValue}
                      setText={setText}
                      multiSelectData={multiSelectData}
                      limit={limit}
                      handleApplyFilter={handleApplyFilter}
                      handleFilterClear={handleFilterClear}
                    />
                  </div>
                </div>
              </div>
            </div>

            {fetching && offset === 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : clientMeetUpChecklistData?.length > 0 || data?.length > 0 ? (
              <AllClientMeetUpStatusTable
                data={data}
                handleEditMeetUp={handleEditMeetUp}
              />
            ) : (
              fetching === false &&
              clientMeetUpChecklistData?.length === 0 && (
                <div className="mt-5 pb-5">
                  <EmptyListPage
                    title="No Meet Up List Found!"
                    imageWidth="30%"
                  />
                </div>
              )
            )}

            {/* //Drawer  */}
            {isDrawerOpen && (
              <AllClientMeetUpRightDrawer
                isRight={true}
                isOpen={isDrawerOpen}
                onClose={closeDrawer}
                history={history}
                clientCode={clientCode}
                singleClientMeetUpCheckListData={
                  singleClientMeetUpCheckListData
                }
                loginData={loginData}
                fetching={fetching}
              />
            )}
          </div>
        </div>

        <Toaster />
        {handleErrorModal()}
      </div>
      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.clientDirectory.fetching,
  error: state.clientDirectory.error,
  statusCode: state.clientDirectory.statusCode,
  success: state.clientDirectory.success,
  message: state.clientDirectory.message,
  totalCount: state.clientDirectory.totalCount,
  finacUser: state.auth.finacUsersList,
  clientMeetUpChecklistData: state.clientDirectory.clientMeetUpChecklistData,
  loginData: state.auth.loginData,
  singleClientMeetUpCheckListData:
    state.clientDirectory.singleClientMeetUpChecklistData,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSuccess: () => dispatch(resetClientDirectorySuccess()),
  dispatchResetError: () => dispatch(resetClientDirectoryError()),
  dispatchResetFinacUsersList: () => dispatch(resetFinacUsersList()),
  dispatchResetMessage: () => dispatch(resetClientDirectoryMessage()),
  dispatchResetStatusCode: () => dispatch(resetClientDirectoryStatusCode()),
  dispatchResetFetching: () => dispatch(resetClientDirectoryFetching()),
  dispatchGetClientMeetUpData: (data: GetClientMeetUpChecklistPayloadType) =>
    dispatch(getClientMeetUpChecklistAction(data)),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dipatchResetClientMeetUpChecklistAction: () =>
    dispatch(resetClientMeetUpChecklistData()),
  dispatchResetSingleClientMeetUpChecklist: () =>
    dispatch(resetSingleClientMeetUpCheklistData()),
  dispatchGetSingleClientMeetUpList: (
    data: GetSingleClientMeetUpChecklistPayloadType
  ) => dispatch(getSingleClientMeetUpChecklistAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllClientMeetUpStatus);
